import state from './moduleTelefoneUtilState'
import mutations from './moduleTelefoneUtilMutations'
import actions from './moduleTelefoneUtilActions'
import getters from './moduleTelefoneUtilGetters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
